import {
	MenuCameraMovePadButton,
	MenuCutawayButton,
	MenuFirstPersonButton,
	MenuGridButton,
	MenuLayersButton,
	MenuFinishesButton,
	MenuObjectLayersButton,
	MenuResetViewButton,
	MenuRoomMapButton,
	MenuShadowsButton,
	MenuSourceLightsButton,
	MenuSunControlButton,
} from "./MenuButtons";
import type { DrawerButtonContext, EditorToolRailItem } from "./types";

interface ThreeDButtonsContext extends DrawerButtonContext {
	isReadOnly: boolean;
	cutaway: boolean;
	roomMap: boolean;
	sunControl: boolean;
	cameraMovePad: boolean;
	firstPerson: boolean;
	shadows: boolean;
	sourceLights: boolean;
	grid: boolean;
	onToggleCutaway: () => void;
	onToggleRoomMap: () => void;
	onToggleSunControl: () => void;
	onToggleCameraMovePad: () => void;
	onToggleFirstPerson: () => void;
	onToggleShadows: () => void;
	onToggleSourceLights: () => void;
	onToggleGrid: () => void;
	onResetView: () => void;
}

/** Кнопки рейки трёхмерного вида. */
export const threeDButtons = (context: ThreeDButtonsContext): EditorToolRailItem[] => [
	MenuLayersButton(context),
	...(!context.isReadOnly ? [MenuObjectLayersButton(context), MenuFinishesButton(context)] : []),
	MenuCutawayButton({ isEnabled: context.cutaway, onClick: context.onToggleCutaway }),
	MenuRoomMapButton({ isEnabled: context.roomMap, onClick: context.onToggleRoomMap }),
	MenuSunControlButton({ isEnabled: context.sunControl, onClick: context.onToggleSunControl }),
	MenuCameraMovePadButton({
		isEnabled: context.cameraMovePad,
		onClick: context.onToggleCameraMovePad,
	}),
	MenuFirstPersonButton({ isEnabled: context.firstPerson, onClick: context.onToggleFirstPerson }),
	MenuShadowsButton({ isEnabled: context.shadows, onClick: context.onToggleShadows }),
	MenuSourceLightsButton({
		isEnabled: context.sourceLights,
		onClick: context.onToggleSourceLights,
	}),
	MenuGridButton({ isEnabled: context.grid, onClick: context.onToggleGrid }),
	MenuResetViewButton({ onClick: context.onResetView }),
];
